import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import LuminaSidebar from './LuminaSidebar';
import LuminaTopbar from './LuminaTopbar';
import LuminaChatbot from '../lumina/LuminaChatbot';
import GuidedDemoModal from '../shared/GuidedDemoModal';
import BackgroundJobsIndicator from '../lumina/BackgroundJobsIndicator';
import { BackgroundJobsProvider } from '../../contexts/BackgroundJobsContext';
import { useAuth } from '../../contexts/AuthContext';

const LuminaLayout = () => {
  const [collapsed, setCollapsed] = useState(() => window.innerWidth < 768);
  const [showDemo, setShowDemo] = useState(false);
  const [role, setRole] = useState(() => sessionStorage.getItem('lumina-role') || 'provider');
  const navigate = useNavigate();
  const location = useLocation();
  const { authFetch } = useAuth();

  useEffect(() => { sessionStorage.setItem('lumina-role', role); }, [role]);

  // Auto-collapse on mobile
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setCollapsed(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  // Auto-detect MA routes — keeps role state in sync with the URL.
  // `role` is intentionally read here without being a dep: re-running on
  // role change would no-op (the equality guard catches it) but adding it
  // keeps the linter happy at zero behavioral cost.
  useEffect(() => {
    if (location.pathname.startsWith('/lumina/ma') && role !== 'ma') {
      setRole('ma');
    }
  }, [location.pathname, role]);

  const handleRoleSwitch = (newRole) => {
    setRole(newRole);
    if (newRole === 'ma' && !location.pathname.startsWith('/lumina/ma')) {
      navigate('/lumina/ma');
    } else if (newRole === 'provider' && location.pathname.startsWith('/lumina/ma')) {
      navigate('/lumina');
    }
  };

  const isMA = role === 'ma';

  return (
    <BackgroundJobsProvider authFetch={authFetch}>
    <div className={`min-h-screen transition-colors duration-200 ${isMA ? 'bg-[#fafafa]' : 'bg-slate-50'}`}>
      <LuminaTopbar onStartTour={() => setShowDemo(true)} collapsed={collapsed} role={role} onRoleSwitch={handleRoleSwitch} />
      <LuminaSidebar collapsed={collapsed} setCollapsed={setCollapsed} role={role} />
      <div className={`transition-all duration-300 pt-14 ${collapsed ? 'ml-16' : 'ml-60'}`}>
        <main className="p-4 sm:p-6 pb-20">
          <Outlet />
        </main>
      </div>
      <LuminaChatbot />
      <GuidedDemoModal app="lumina" open={showDemo} onOpenChange={setShowDemo} />
      <BackgroundJobsIndicator />
    </div>
    </BackgroundJobsProvider>
  );
};

export default LuminaLayout;
